<div class="container-fluid">
  <div class="card">
    <div class="title">
      <div>서비스 이용약관</div>
    </div>
    <div class="card-body top" *ngIf="service">
      <div class="content">{{ service }}</div>
    </div>
  </div>
</div>
